/**
 *  Ensures that all links that have a target of _blank, i.e.
 *  should open a page in a new tab or window have the property security
 *  features applied
 */

export default function generateSecureRel(target, rel) {
  if (!target || !target.includes('_blank')) {
    return rel
  }
  if (!rel) {
    return 'noopener noreferrer'
  }

  let secureRel = rel
  if (!secureRel.includes('noopener')) {
    secureRel = `${secureRel} noopener`
  }
  if (!secureRel.includes('noreferrer')) {
    secureRel = `${secureRel} noreferrer`
  }

  return secureRel.trim()
}
